
import Vue from 'vue';
import { transformLink } from '~/transforms/transformComponents';

export default Vue.extend({
  props: {
    image: {
      type: Object,
    },
    headline: {
      type: String,
    },

    link: {
      type: Object,
    },
    linkLabel: {
      type: String,
    },
  },
  mounted() {},
  methods: {
    transformLink,
  },
});
